import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { API_KEY } from 'constants/apis';

import {
    IFeedActivityDataResponse,
    IMainCountersData,
    IFeedOrganizationSearchedData,
    IFeedItemsDataResponse,
    IGetFeedOrganizationsSearchParams,
    IGetFeedItemsParams,
    IFeedStatsData,
} from 'types/interfaces';
import { organizationsHeaderMock } from 'mockedData/mainPage';

export const FeedApi = {
    getFeedActivityData: async (): Promise<AxiosResponse<any>> => {
        //axiosInstance.get<IFeedActivityDataResponse>('feed/activity'),
      const jsonRes = await fetch('/feed_activity_mock.json');
      const data = await jsonRes.json();

      return Promise.resolve({
        data,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      })
    },
    getFeedMainInfo: (): Promise<AxiosResponse<IMainCountersData>> =>
        //axiosInstance.get<IMainCountersData>(`organization/${API_KEY}/last-update`)      
      Promise.resolve({
        data: organizationsHeaderMock,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      }),
    getFeedOrganizationsSearch: (
        params: IGetFeedOrganizationsSearchParams,
    ): Promise<AxiosResponse<any>> =>
      Promise.resolve({
        data: [],
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      }),
        //axiosInstance.get<IFeedOrganizationSearchedData>('feed/search/organization', { params }),
    // getFeedOrganizationsSearch: (
    //   params: IGetFeedOrganizationsSearchParams,
    // ): Promise<AxiosResponse<any>> =>
    //   Promise.resolve({
    //     data: {data: {}},
    //     status: 200,
    //     statusText: "OK",
    //     headers: {},
    //     config: {},
    //     request: {},
    //   }),
    getFeedItems: async (params: IGetFeedItemsParams): Promise<AxiosResponse<IFeedItemsDataResponse>> => {
      //axiosInstance.get<IFeedItemsDataResponse>('feed/list', { params }),

      const jsonRes = await fetch('/feed_list_mock.json');
      const data = await jsonRes.json();
        
      return Promise.resolve({
        data,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      })
    },
    getFeedStatsData: async (): Promise<AxiosResponse<any>> => {
      //axiosInstance.get<IFeedStatsData>('feed/stats'),

      const jsonRes = await fetch('/feed_stats_mock.json');
      const data = await jsonRes.json();
        
      return Promise.resolve({
        data,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      })
    }
};
